import App from './App.js';
import Auth from './Auth/Auth.js';
import Info from './Info/Info.js';
import ReportContainer from './Report/ReportContainer.js';
import InfoContainer from './Info/InfoContainer.js';
import TimeTrackingContainer from './TimeTrackingModal/TimeTrackingContainer.js';
import NotFound from './NotFound.js';
import store from 'store/store.js';

export const routes = [
            {
                path:    '/auth',
                component: Auth,
                isAuth: false
            },
            {
                path:    '/report',
                component: ReportContainer,
                isAuth: true
            },
            {

                path:    '/view_emp',
                component: InfoContainer,
                isAuth: true
            },
            //новые пути писать до этой строчки
            {
                path:    '/logout'               
            },
            {
                path:    '/404',
                name: '404',
                component: NotFound,
            }
];


// WEBPACK FOOTER //
// ./src/router.js